// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"19bda563","729":"fa5f9b0c"}[chunkId] + ".chunk.js";
};